import { render, staticRenderFns } from "./faqCollectionPage.vue?vue&type=template&id=8eb7917a&"
import script from "./faqCollectionPage.vue?vue&type=script&lang=js&"
export * from "./faqCollectionPage.vue?vue&type=script&lang=js&"
import style0 from "./faqCollectionPage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports